<ion-header>
  <ion-toolbar>
    <ion-title (press)="titlePressed()" (pressup)="titleReleased()">{{'settings-page.title' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="has-header">
  <ion-list>
    <ion-item *ngIf="isBetaTester">
      <ion-toggle [(ngModel)]="allTime" data-cy="all-time-toggle" (ionChange)="allTimeToggleChanged()"
                color="primary">{{"my-ascent-list-component.all-time-mode" |translate}}</ion-toggle>
    </ion-item>
    <ion-item *ngIf="showDonateButton()" detail (click)="donateButtonClicked()">
      <ion-button slot="start" size="medium" fill="clear">
        donate
        <ion-icon name="diamond-outline" slot="start"></ion-icon>
      </ion-button>
    </ion-item>
    <ion-item detail class="select-option">
      <ion-icon name="language-outline" slot="start"></ion-icon>
      <ion-select slot="start" class="form-control" [(ngModel)]="selectedLanguage" name="selectedLanguage"
        [selectedText]="displayNameByLanguage[selectedLanguage]"
        [label]="('language-switcher-component.select-language' | translate)" (ionChange)="selectedLanguageChanged()">
        <ion-select-option *ngFor="let lang of availableLanguages" value="{{lang}}">{{ displayNameByLanguage[lang]
          }}</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item detail (click)="openInstagram()">
      <ion-button slot="start" size="medium" fill="clear">
        {{"settings-page.instagram" | translate}}
        <ion-icon name="logo-instagram" slot="start"></ion-icon>
      </ion-button>
    </ion-item>
    <ion-item *ngIf="false" detail (click)="openBoulderBookShop()">
      <ion-button slot="start" size="medium" fill="clear">
        {{"settings-page.shop" | translate}}
        <ion-icon name="cart-outline" slot="start"></ion-icon>
      </ion-button>
    </ion-item>
    <ion-item detail (click)="showFeedbackModal()">
      <ion-button slot="start" size="medium" fill="clear">
        {{"settings-page.provide-feedback" | translate}}
        <ion-icon name="megaphone-outline" slot="start"></ion-icon>
      </ion-button>
    </ion-item>
    <ion-item detail *ngIf="!guestService.isGuest()" (click)="reset()">
      <ion-button slot="start" data-cy="reset-button" size="medium" fill="clear">
        {{"settings-page.reset" | translate}}
        <ion-icon name="hammer" slot="start"></ion-icon>
      </ion-button>
    </ion-item>
    <ion-item detail *ngIf="!guestService.isGuest()" (click)="manageWalls()">
      <ion-button slot="start" size="medium" fill="clear">
        {{"settings-page.manage-walls" | translate}}
        <ion-icon name="images-outline" slot="start"></ion-icon>
      </ion-button>
    </ion-item>
    <ion-item class="select-option">
      <ion-icon name="cellular-outline" slot="start"></ion-icon>
      <ion-select slot="start" class="form-control" [(ngModel)]="gradeSystem" 
        [label]="('settings-page.grading-system' | translate)" (ionChange)="gradeSystemChanged($event)">
        <ion-select-option value="font">Font (fb)</ion-select-option>
        <ion-select-option value="v">V grades</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item>
      <ion-button slot="end" (click)="logout()" size="medium" fill="clear">
        <ion-icon name="power" slot="start"></ion-icon>
        {{"me-page.logout" | translate}}
      </ion-button>
    </ion-item>
    <ion-item>
      <p> </p>
    </ion-item>
    <ion-item class="delete-account" *ngIf="!guestService.isGuest()" detail (click)="deleteAccount()">
      <ion-button slot="start" size="medium" fill="clear">
        {{"settings-page.delete-account" | translate}}
        <ion-icon name="trash-outline" slot="start"></ion-icon>
      </ion-button>
    </ion-item>
  </ion-list>
</ion-content>